<template>
    <my-form 
    v-model="form" 
    table 
    @cancle="cancleHandler" 
    @submit="submitHandler">

        <el-form-item 
        label="审核意见" 
        prop="shyj" 
        class="table-full-row" 
        >
            <el-input v-model="form.shyj" type="textarea" :rows="4"></el-input>
        </el-form-item>

        <template slot="btn" slot-scope="scope" class="btn">
            <el-button 
            @click="scope.submitHandler" 
            type="primary" 
            icon="el-icon-circle-check"
            >
                提交
            </el-button>

            <el-button 
            icon="el-icon-circle-close" 
            @click="scope.cancleHandler"
            >
                取消
            </el-button>
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    props: {
        row: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        var that = this;
        return {
            form: {
                shyj: '',
                rows: ''
            }
        }
    },
    methods: {
        submitHandler() {
            this.form.rows = this.row.orderscode;

            this.$post(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/gkzb-gmbs/bssh.json`, this.form, (data, res) => {
                ShowMsg('核实成功', 'success');
                this.cancleHandler();
            });
        },
        cancleHandler() {
            this.$emit('cancle');
        }
    }
}
</script>

<style lang="scss" scoped>

</style>